import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { Table } from "../../components/Shared/Table/Table";
import { emailTemplateQueryKeys } from "../../data/emailTemplates/queryKeys";
import { IEmailTemplate } from "../../models/emailTemplates/EmailTemplate";
import { createColumnHelper } from "@tanstack/react-table";
import ActionButtonContainer from "../Shared/ActionButtonContainer";
import ActionButton from "../Shared/ActionButton";
import { PencilAltIcon } from "@heroicons/react/outline";
import { EditEmailTemplateFlyout } from "./EditEmailTemplateFlyout";

const colHelper = createColumnHelper<IEmailTemplate>();

export default function EmailTemplatesList({ agencyId }: { agencyId: string }) {
  const [editOpen, setEditOpen] = useState(false);
  const [editId, setEditId] = useState<string>();

  const handleEditClick = (emailTemplate: IEmailTemplate) => {
    setEditId(emailTemplate.id);
    setEditOpen(true);
  }

  const cols = [
    colHelper.accessor("name", {
      header: "Name",
    }),
    colHelper.display({
      header: "Actions",
      cell: (info) => (
        <ActionButtonContainer>
          <ActionButton onClick={() => handleEditClick(info.row.original)} tooltip="Edit" Icon={PencilAltIcon} />
        </ActionButtonContainer>
      )
    })
  ]

  useEffect(() => {
    document.title = "EstateTrack Portal | Email Templates";
  }, []);

  return (
    <>
      <EditEmailTemplateFlyout
        open={editOpen}
        setOpen={setEditOpen}
        agencyId={agencyId}
        emailTemplateId={editId!}
      />
      <div className="divide-y space-y-6">
        <div className="-mx-6 px-6">
          <h3 className="text-xl font-medium text-gray-900">
            Email Templates
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Customise your Email Templates here.
          </p>
        </div>
        <div>
          <Table<IEmailTemplate>
            url="/emailtemplate"
            queryKey={emailTemplateQueryKeys.all()}
            columns={cols}
            onRowClick={(row) => handleEditClick(row.original)}
            enablePagination={false}
          />
        </div>
      </div>
    </>
  );
}
